module.exports = __webpack_public_path__ + "static/img/img-section03@w.3fa355e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/img-section03@w.png
// module id = W+Wf
// module chunks = 0